<template>
  <div class="data_body">
    <div style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;">
      <!-- <div id="cateRank" class="echart" style="width: 100%; height: 100%"></div> -->
      <highcharts :options="option" style="width: 95%; height: 95%"></highcharts>
    </div>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import HighCharts from 'highcharts'
//和弦图的引入依赖
// import column from 'highcharts/modules/column';
// column(HighCharts);

export default {
  components: {
    highcharts: Chart,
  },
  props: {
    weekCourse2: {
      type: Array,
    },
  },
  data() {
    return {
      chartObj: null,
      ooption: {
        data: [],
      },
      option: {
        chart: {
          type: 'column',
          backgroundColor: 'rgba(0,0,0,0)'
        },
        title: {
          text: null
        },
        credits: {
          enabled: false//不显示LOGO
        },
        xAxis: {
          categories: [
          ]
        },
        yAxis: [{
          allowDecimals: false,
          min: 0,
          title: {
            text: '课程总数'
          }
        },
          // {
          //   title: {
          //     text: '项目总数'
          //   },
          //   opposite: true
          // }
        ],
        legend: {
          shadow: false
        },
        tooltip: {
          shared: true
        },
        plotOptions: {
          column: {
            grouping: false,
            shadow: false,
            borderWidth: 0,
            dataLabels: {
              enabled: true,  //显示数量提示
              color: '#000000',
              formatter : function() {
                var employee = this.point.series.chart.series[0].yData[this.point.index];
                var optimizedEmployee = this.point.series.chart.series[1].yData[this.point.index];
                var employeePercentage = 0;
                if(optimizedEmployee > employee){
                  employeePercentage = ((optimizedEmployee - employee) / optimizedEmployee) * 100
                }
                if (this.series.name === '本月课程总数') {
                  return  employeePercentage.toFixed(1) + '%';
                } else {
                  return '';
                }
              }
            }
          }
        },
        series: [{
          name: '上月课程总数',
          color: 'rgba(165,170,217,1)',
          data: [],
          pointPadding: 0.3, // 通过 pointPadding 和 pointPlacement 控制柱子位置
          // pointPlacement: -0.2
        }, {
          name: '本月课程总数',
          color: 'rgba(126,86,134,.9)',
          data: [],
          pointPadding: 0.4,
          // pointPlacement: -0.2
        },
          //  {
          //   name: '上周项目总数',
          //   color: 'rgba(248,161,63,1)',
          //   data: [153, 178, 195],
          //   pointPadding: 0.3,
          //   pointPlacement: 0.2,
          //   yAxis: 1  // 指定数据列所在的 yAxis
          // }, {
          //   name: '本周项目总数',
          //   color: 'rgba(186,60,61,.9)',
          //   data: [203, 198, 208],
          //   pointPadding: 0.4,
          //   pointPlacement: 0.2,
          //   yAxis: 1
          // }
        ]
      }
    };
  },
  methods: {
    setChart() {
      // 雷达图显示的标签
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      newPromise.then(() => {
        const chartObj = Highcharts.chart('cateRank', this.option);
        // 初始化雷达图
        // this.chartObj = chartObj;
        // this.chartObj.setOption(this.option);
      });
    },
    setArray(array) {
      this.option.xAxis.categories = []
      this.option.series[0].data = []
      this.option.series[1].data = []
      for (var i = 0; i < array.length; i++) {
        this.option.xAxis.categories.push(array[i].name)
        this.option.series[0].data.push(array[i].lastCourse)
        this.option.series[1].data.push(array[i].toCourse)
      }
    }
  },
  watch: {
    weekCourse2: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.setArray(newValue)
        this.$forceUpdate();
      },
    },
  },
  mounted() {
    this.setArray(this.weekCourse2)
    // this.setChart();

  },
};
</script>

<style scoped>
.data_body {
  height: 100%;
  /* display: flex; */
  position: relative;
  border-radius: 5px;
  /* border: 1px solid #eee; */
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0;
  width: 95%;
  /* background: #fff; */
}
</style>


// WEBPACK FOOTER //
// src/components/pages/dataBoardNew/course/chartList/courseNum.vue